import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CapabilityEngineService } from '../../capabilityEngine.service';

@Injectable()
export class IncidentsFormsService {

  constructor(private _http: HttpClient,private _capEngineService: CapabilityEngineService) { }

  performPagination(templateId, pageNumber, isHazardForm, displayFieldKey) {
    let header: any = this._capEngineService.getHeaders('viewTaskList');
    header.params = { isHazardForm: isHazardForm, displayFieldKey: displayFieldKey, formType: 'incident' };

    // tslint:disable-next-line:max-line-length
    return this._http.get(environment.serverUrl + '/task/' + templateId + '/tasks/pagination/' + pageNumber, header);
}    

}
 


// WEBPACK FOOTER //
// ./src/app/rFF/services/incidents-forms.service.ts